import { call, put, takeLatest } from 'redux-saga/effects';

import postVacancyResponseAPI, { IPostVacancyResponsePayload } from '../../api/post-vacancy-response';
import {
  receivePostVacancyResponse,
  rejectPostVacancyResponse,
  requestPostVacancyResponse,
} from '../actions/vacancy-page';

interface IPostVacancyResponseAction {
  type: string;
  payload: {
    values: IPostVacancyResponsePayload;
    resetValues: () => void;
  };
}

const postVacancyResponse = function* postVacancyResponse(action: IPostVacancyResponseAction) {
  try {
    yield call(postVacancyResponseAPI, action.payload.values);
    action.payload.resetValues();
    yield put(receivePostVacancyResponse());
  } catch (error) {
    yield put(rejectPostVacancyResponse({ error }));
  }
};

export default function* vacancyResponseWatcher() {
  yield takeLatest(requestPostVacancyResponse, postVacancyResponse);
}
